import * as React from 'react'
import { defineMessages, FormattedHTMLMessage } from 'react-intl'

import Button from '../../../../components/button'
import VideoPopup from '../../../../components/videopopup'

import styles from './hero.module.scss'

const messages = defineMessages({
  button: {
    defaultMessage: 'Kom igång - det är gratis',
    id: 'billing.hero.button',
  },
  heading: {
    defaultMessage: 'Fakturering online. Gratis för alltid.',
    id: 'billing.hero.heading',
  },
  lede: {
    defaultMessage:
      'Skapa och skicka fakturor på några klick. Din kund betalar snabbt med till exempel kort, swish eller Apple pay och betalda fakturor registreras automatiskt. Dooer fakturering är kraftfullt,<br /> enkelt och gratis.',
    id: 'billing.hero.lede',
  },
  punchline: {
    defaultMessage:
      'Tjänsten kräver inte att du är Dooer-kund och den fungerar med alla andra bokföringsbyråer- och program.',
    id: 'billing.hero.punchline',
  },
  reasonText1: {
    defaultMessage: 'fungerar med alla bokföringsbyråer- och program.',
    id: 'billing.hero.reasonText1',
  },
  reasonText2: {
    defaultMessage: 'kräver inte att du är Dooer bokföringskund.',
    id: 'billing.hero.reasonText2',
  },
  reasonText3: {
    defaultMessage: 'tar endast några sekunder att komma igång med.',
    id: 'billing.hero.reasonText3',
  },
  reasonText4: {
    defaultMessage: 'är helt och hållet gratis.',
    id: 'billing.hero.reasonText4',
  },
})

interface IHeroProps {
  variant?: 1 | 2
  cta: () => void
}

function Hero({ cta }: IHeroProps) {
  const [video, toggleVideo] = React.useState(false)

  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <div className={styles.left}>
            <h1 className={styles.heading}>
              <FormattedHTMLMessage {...messages.heading} />
            </h1>
            <p className={styles.lede}>
              <FormattedHTMLMessage {...messages.lede} />
            </p>

            <Button bankId onClick={cta} variant="success">
              <FormattedHTMLMessage {...messages.button} />
            </Button>
          </div>
        </div>
      </div>

      {video && (
        <VideoPopup
          close={() => toggleVideo(false)}
          video={{
            src:
              'https://www.youtube.com/embed/videoseries?list=PLvvMaULpN3LYzAVgu44whvHxew_bSzi59&autoplay=1&rel=0&controls=0&showinfo=0',
            title: 'Dooer gratis fakturering',
          }}
        />
      )}
    </div>
  )
}

export default Hero
